import { invoiceTypes } from "@/constants/invoiceTypes";

const invoiceTypeMap = invoiceTypes.reduce((acc, type) => {
  acc[type.Code] = type.Description;
  return acc;
}, {} as Record<string, string>);

export const getInvoiceTypeDescription = (code: string): string => {
  return invoiceTypeMap[code] || code; 
};